// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2vqij","header":"style_header__FlwkG","title":"style_title__2rhui","subtitle":"style_subtitle__a2yQh","content":"style_content__2_xyP"};